import { render, staticRenderFns } from "./FirmsHeader.vue?vue&type=template&id=35e8110c&scoped=true"
import script from "./FirmsHeader.vue?vue&type=script&lang=ts"
export * from "./FirmsHeader.vue?vue&type=script&lang=ts"
import style0 from "./FirmsHeader.vue?vue&type=style&index=0&id=35e8110c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8110c",
  null
  
)

export default component.exports